import * as React from 'react';
import { SVGProps } from 'react';

const CarTransactionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_7808_197519"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={-1}
      y={0}
      width={33}
      height={32}
    >
      <rect x={-0.00195312} width={32} height={32} fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0_7808_197519)">
      <mask
        id="mask1_7808_197519"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={-1}
        y={0}
        width={33}
        height={24}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.7172 0.440557C7.90777 0.75524 7.14204 1.55007 6.11093 3.21586C4.82387 5.29277 3.6029 7.50571 2.59172 9.32072C1.69067 10.9368 1.30676 12.3813 1.30676 14.1516C1.30676 15.8235 1.85746 17.2152 2.61794 18.9937V21.7974C2.61794 22.4968 3.20535 23.0663 3.92912 23.0663H5.89589C6.61966 23.0663 7.20707 22.4968 7.20707 21.7974V20.5285H24.2524V21.7974C24.2524 22.4968 24.8398 23.0663 25.5636 23.0663H27.5304C28.2542 23.0663 28.8416 22.4968 28.8416 21.7974V18.9937C29.602 17.2132 30.1527 15.8235 30.1527 14.1516C30.1527 12.3813 29.7688 10.9368 28.8678 9.32072C27.8692 7.52804 26.6398 5.29886 25.3486 3.21586C24.3175 1.55007 23.5528 0.756255 21.7413 0.440557C19.9119 0.122828 18.2262 0 15.7297 0C13.2333 0 11.5466 0.122828 9.7172 0.440557ZM6.80676 7.13821C7.30815 6.26623 7.82948 5.37801 8.36025 4.52126C9.23821 3.10519 9.47737 3.06458 10.1823 2.93973C11.8459 2.65346 13.4015 2.53977 15.7301 2.53977C18.0588 2.53977 19.6154 2.65245 21.278 2.93973C21.9829 3.06458 22.2221 3.10519 23.1 4.52126C23.635 5.38512 24.1626 6.28248 24.6671 7.16257C22.7581 7.44173 19.3962 7.84168 15.7301 7.84168C11.7337 7.84168 8.49661 7.41432 6.80676 7.13821ZM3.93176 14.1523C3.93176 12.0693 4.59469 11.0796 5.4842 9.48485C6.84887 9.7437 10.6859 10.3781 15.7324 10.3781C20.2974 10.3781 24.3348 9.80055 26.0037 9.52545C26.8753 11.0867 27.533 12.0744 27.533 14.1523C27.533 16.2739 25.7561 17.9915 23.5649 17.9915H7.89887C5.70867 17.9915 3.93176 16.2739 3.93176 14.1523ZM27.9242 5.30114L29.3476 7.83992C30.2528 7.83992 31.4665 7.59122 31.4665 6.58423V5.93659C31.4665 5.58638 31.1728 5.30114 30.8109 5.30114H27.9242ZM0.653637 5.30114C0.2928 5.30114 -0.00195312 5.58638 -0.00195312 5.93659V6.58423C-0.00195312 7.59122 1.21168 7.83992 2.11692 7.83992L3.54138 5.30114H0.653637ZM22.2897 13.5492C22.2897 14.5998 23.1698 15.4515 24.2565 15.4515C25.3421 15.4515 26.2233 14.5998 26.2233 13.5492C26.2233 12.4985 25.3421 11.6458 24.2565 11.6458C23.1698 11.6458 22.2897 12.4985 22.2897 13.5492ZM5.24236 13.5492C5.24236 14.5998 6.12348 15.4515 7.20914 15.4515C8.29479 15.4515 9.17591 14.5998 9.17591 13.5492C9.17591 12.4985 8.29479 11.6458 7.20914 11.6458C6.12348 11.6458 5.24236 12.4985 5.24236 13.5492ZM11.1461 14.1837C10.7852 14.1837 10.4905 14.4679 10.4905 14.8182C10.4905 15.1674 10.7852 15.4516 11.1461 15.4516H20.3243C20.6862 15.4516 20.9799 15.1674 20.9799 14.8182C20.9799 14.4679 20.6862 14.1837 20.3243 14.1837H11.1461Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_7808_197519)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-5.24609 28.1417H36.7117V-5.07568H-5.24609V28.1417Z"
          fill="#C8C6C6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-5.24609 31.7215H36.7117V-8.88281H-5.24609V31.7215Z"
          fill="#C8C6C6"
        />
      </g>
      <mask
        id="mask2_7808_197519"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={3}
        y={25}
        width={6}
        height={6}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.14648 28.1701C3.14648 29.572 4.32025 30.7079 5.76885 30.7079C7.21639 30.7079 8.39121 29.572 8.39121 28.1701C8.39121 26.7682 7.21639 25.6323 5.76885 25.6323C4.32025 25.6323 3.14648 26.7682 3.14648 28.1701Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_7808_197519)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-2.09766 35.7833H13.6365V20.5566H-2.09766V35.7833Z"
          fill="#C8C6C6"
        />
      </g>
      <mask
        id="mask3_7808_197519"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={13}
        y={25}
        width={6}
        height={6}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6387 28.1701C13.6387 29.572 14.8124 30.7079 16.261 30.7079C17.7096 30.7079 18.8834 29.572 18.8834 28.1701C18.8834 26.7682 17.7096 25.6323 16.261 25.6323C14.8124 25.6323 13.6387 26.7682 13.6387 28.1701Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_7808_197519)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.39453 35.7833H24.1287V20.5566H8.39453V35.7833Z"
          fill="#C8C6C6"
        />
      </g>
      <mask
        id="mask4_7808_197519"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={24}
        y={25}
        width={6}
        height={6}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.125 28.1706C24.125 29.5724 25.2988 30.7084 26.7474 30.7084C28.196 30.7084 29.3697 29.5724 29.3697 28.1706C29.3697 26.7687 28.196 25.6328 26.7474 25.6328C25.2988 25.6328 24.125 26.7687 24.125 28.1706Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_7808_197519)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8809 35.7833H34.615V20.5566H18.8809V35.7833Z"
          fill="#C8C6C6"
        />
      </g>
    </g>
  </svg>
);
export default CarTransactionIcon;
